(() => {
  'use strict';
  const recentKey = 'wokora-recent-products-v1';
  const rootPath = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };
  const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const money = cents => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl-BE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(value);
    } catch { return `€${value.toFixed(2).replace('.', ',')}`; }
  };
  const readRecent = () => {
    try {
      const value = JSON.parse(localStorage.getItem(recentKey) || '[]');
      return Array.isArray(value) ? value.filter(Boolean) : [];
    } catch { return []; }
  };
  const writeRecent = list => { try { localStorage.setItem(recentKey, JSON.stringify(list.slice(0, 8))); } catch {} };
  const notifyContent = root => {
    if (!(root instanceof Element)) return;
    document.dispatchEvent(new CustomEvent('wokora:content-updated', { detail: { root } }));
  };

  const currentHandle = document.body?.dataset.currentProductHandle;
  if (currentHandle) writeRecent([currentHandle, ...readRecent().filter(handle => handle !== currentHandle)]);

  const withPreviewTheme = url => {
    try {
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
    } catch {}
    return url;
  };

  async function enhanceMerchRail(section) {
    const sort = section.dataset.merchSort;
    const source = section.dataset.merchUrl;
    const track = section.querySelector('[data-merch-track]');
    const count = Math.max(1, Number(section.dataset.merchCount || 10));
    if (!source || !track || !sort || sort === 'manual') return;
    try {
      const url = withPreviewTheme(new URL(source, window.location.origin));
      url.searchParams.set('sort_by', sort);
      const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' }, credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Merchandising fetch failed: ${response.status}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cards = [...doc.querySelectorAll('#MainContent .product-card')].slice(0, count);
      if (!cards.length) return;
      track.replaceChildren(...cards.map(card => card.cloneNode(true)));
      track.scrollLeft = 0;
      section.dataset.merchEnhanced = 'true';
      notifyContent(track);
    } catch (error) { console.warn('WOKORA homepage merchandising fallback used', error); }
  }
  document.querySelectorAll('[data-home-merch-rail]').forEach(enhanceMerchRail);

  function recentCard(product) {
    const availableVariant = (product.variants || []).find(variant => variant.available) || (product.variants || [])[0];
    const price = availableVariant?.price ?? product.price ?? 0;
    const image = product.featured_image || (product.images || [])[0] || '';
    const productUrl = product.url || `${rootPath()}products/${encodeURIComponent(product.handle || '')}`;
    const canBuy = Boolean(availableVariant?.available);
    const form = canBuy ? `<form action="${esc(`${rootPath()}cart/add`)}" method="post" data-ajax-cart-form><input type="hidden" name="id" value="${esc(availableVariant.id)}"><input type="hidden" name="quantity" value="1"><button class="w17-recent-card__atc" type="submit" aria-label="Voeg ${esc(product.title)} toe">Toevoegen</button></form>` : '<button class="w17-recent-card__atc" type="button" disabled>Uitverkocht</button>';
    return `<article class="w17-recent-card"><a class="w17-recent-card__media" href="${esc(productUrl)}">${image ? `<img src="${esc(image)}" alt="${esc(product.title)}" loading="lazy">` : ''}</a><div class="w17-recent-card__body"><div class="w17-recent-card__vendor">${esc(product.vendor || '')}</div><a class="w17-recent-card__title" href="${esc(productUrl)}">${esc(product.title)}</a><div class="w17-recent-card__foot"><span class="w17-recent-card__price">${money(price)}</span>${form}</div></div></article>`;
  }

  async function loadRecentlyViewed(section) {
    const track = section.querySelector('[data-recently-viewed-track]');
    if (!track) return;
    const max = Math.max(2, Number(section.dataset.recentlyViewedCount || 6));
    const handles = readRecent().filter(handle => handle && handle !== currentHandle).slice(0, max);
    if (!handles.length) return;
    const products = await Promise.all(handles.map(async handle => {
      try {
        const url = withPreviewTheme(new URL(`${rootPath()}products/${encodeURIComponent(handle)}.js`, window.location.origin));
        const response = await fetch(url.toString(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (!response.ok) return null;
        return await response.json();
      } catch { return null; }
    }));
    const valid = products.filter(Boolean);
    if (!valid.length) return;
    track.innerHTML = valid.map(recentCard).join('');
    section.hidden = false;
    notifyContent(track);
  }
  document.querySelectorAll('[data-recently-viewed-section]').forEach(section => { loadRecentlyViewed(section).catch(error => console.warn('WOKORA recently viewed unavailable', error)); });
})();
